import styled from '@emotion/styled'
import theme from '../../../../../../styles/theme'
import { HeaderLarge500Style } from '../../../../../../styles/Text.styles'
import { baseAccordionHeader } from '../../../../../ui_reusable/styles/Panel.styles'

// Import shared styles from CreatorAccordion
export {
  AccordionContainer,
  PanelContainer,
  PanelContent, // <-- inherit directly, do not override
} from '../../../../../ui_reusable/styles/CreatorAccordion.styles'

// Override DynamicHeader to add position: relative for absolute positioning of ButtonKeepersContainer
export const DynamicHeader = styled.div`
  ${baseAccordionHeader}
  background-color: transparent;
  padding: 1rem;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  position: relative; // Add this to make absolute positioning work correctly
  gap: 1rem;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  &:hover {
    background-color: ${(props) =>
      props.disabled ? 'transparent' : 'rgba(0, 0, 0, 0.03)'};
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
    border-bottom-left-radius: ${(props) => (props.isActive ? '0' : '1.5rem')};
    border-bottom-right-radius: ${(props) => (props.isActive ? '0' : '1.5rem')};
  }
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%; // Make it 100% round
  padding: 0.25rem; // Add some padding for the hover effect
  transition: background-color 0.2s ease; // Add transition for smooth hover

  svg {
    width: 1.5rem;
    height: 1.5rem;
    /* color: ${theme.colors.secondHighlight}; */ /* Removed color styling */
  }
`

// Only define unique styles for BuildScenarioAccordion
export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0; // Added to allow shrinking
`

export const EditableHeaderInput = styled.input`
  ${HeaderLarge500Style}
  background: transparent;
  border: none;
  outline: none;
  padding: 2px 0;
  flex: 1;
  color: ${theme.colors.standardText};
  min-width: 0; // Added to prevent overflow

  &:focus {
    background-color: ${theme.colors.background};
    border-radius: 4px;
    padding: 2px 6px;
  }
`

export const EditIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 50%; // Make it round

  /* Removed background-color and hover effect */
  /* &:hover {
    background-color: ${theme.colors.veryVeryFadedText};
  } */
`

export const ButtonKeepersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end; // Keep for internal alignment of icons
  gap: 0.3rem;
  flex-shrink: 0; // Added: Prevents this container from shrinking
  // position: absolute; // Removed
  // top: 50%; // Removed
  // right: 1rem; // Removed
  // transform: translateY(-50%); // Removed
`
